// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ea962550c2f92c9b67da","655":"253c40eaecf9f294e8f7"}[chunkId] + ".js";
};